import gql from 'graphql-tag'
import client from '@stores/apollo'

interface Payload {
  data: {
    viewer: {
      company: {
        types: { employeeType: string[] }
      }
    }
  }
}

export default function employeeTypes(): Promise<string[]> {
  return client.gql.query({ query }).then(
    ({
      data: {
        viewer: {
          company: {
            types: { employeeType },
          },
        },
      },
    }: Payload) => employeeType
  )
}

export const query = gql`
  query employeeTypes {
    viewer {
      company {
        types {
          employeeType
        }
      }
    }
  }
`
